import { SetPasswordFlow } from './SetPasswordFlow'

/**
 * `/reset-password` — landing page for the password-recovery email link.
 *
 * Handles every shape the recovery link can take (existing session, PKCE
 * `?code=`, or verifier-free `token_hash`+`type=recovery`) via the shared
 * {@link SetPasswordFlow}, then lets the user set a new password.
 */
export function ResetPasswordPage() {
  return (
    <SetPasswordFlow
      linkType="recovery"
      cardTitle="Reset Password"
      formTitle="Set New Password"
      formDescription="Enter your new password below"
      submitLabel="Update Password"
      successTitle="Password Updated"
      successMessage="Your password has been updated successfully."
    />
  )
}
